import type { TypePolicies } from "@apollo/client"

export const typePoliciesCustomFormsFields: TypePolicies = {
  CustomFormsResponse: {
    keyFields: false,
  },
  CustomFormsResponseBankAccountAnswer: {
    keyFields: false,
  },
  CustomFormsResponseFileAnswer: {
    keyFields: false,
  },
  CustomFormsResponseFileAnswerValue: {
    keyFields: false,
  },
  CustomFormsResponseMultiStringAnswer: {
    keyFields: false,
  },
  CustomFormsResponseStringAnswer: {
    keyFields: false,
  },
  CustomFormsResponsePage: {
    keyFields: false,
  },
}
